import { render } from "./DetectableFieldDisplay.vue?vue&type=template&id=227ae98f&scoped=true"
import script from "./DetectableFieldDisplay.vue?vue&type=script&lang=js"
export * from "./DetectableFieldDisplay.vue?vue&type=script&lang=js"

import "./DetectableFieldDisplay.vue?vue&type=style&index=0&id=227ae98f&scoped=true&lang=css"
import "./DetectableFieldDisplay.vue?vue&type=style&index=1&id=227ae98f&lang=css"

import exportComponent from "/builds/vrs/docker/web/app/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-227ae98f"]])

export default __exports__